import React, { useMemo } from "react";
import KPICard from "./KPICard";
import { formatNumber, formatPercentage } from "../../utils/formatters";
import { METRIC_TOOLTIPS } from "../../utils/constants";
import { getCssVar } from "../../utils/cssVar";
import "./KPIGrid.css";

const KPIGrid = ({ report }) => {
  const colors = useMemo(() => ({
    shareOfVoice: getCssVar('--color-primary'),
    estimatedTraffic: getCssVar('--chart-secondary-vert'),
    presenceRate: getCssVar('--chart-primary-2'),
    top10: getCssVar('--chart-secondary-jaune'),
    averagePosition: getCssVar('--chart-secondary-rose'),
    positionedDomains: getCssVar('--chart-secondary-violet'),
    totalSearchVolume: getCssVar('--chart-secondary-bleu'),
  }), []);

  const cards = useMemo(() => [
    {
      key: "shareOfVoice",
      icon: "TrendingUp",
      label: "Part de voix",
      color: colors.shareOfVoice,
      tooltipText: METRIC_TOOLTIPS.SHARE_OF_VOICE,
      getValue: (currentReport) => formatPercentage(currentReport.shareOfVoice),
    },
    {
      key: "estimatedTraffic",
      icon: "Users",
      label: "Trafic estimé",
      color: colors.estimatedTraffic,
      tooltipText: METRIC_TOOLTIPS.ESTIMATED_TRAFFIC,
      getValue: (currentReport) => formatNumber(currentReport.estimatedTraffic),
    },
    {
      key: "presenceRate",
      icon: "Target",
      label: "Taux de présence",
      color: colors.presenceRate,
      tooltipText: METRIC_TOOLTIPS.PRESENCE_RATE,
      getValue: (currentReport) => formatPercentage(currentReport.presenceRate, 0),
    },
    {
      key: "top10",
      icon: "Globe",
      label: "Top 10",
      color: colors.top10,
      tooltipText: METRIC_TOOLTIPS.TOP_10,
      getValue: (currentReport) => {
        const top10Count =
          (currentReport.rank1To3Count || 0) +
          (currentReport.rank4To5Count || 0) +
          (currentReport.rank6To10Count || 0);
        return formatNumber(top10Count);
      },
    },
    {
      key: "averagePosition",
      icon: "MapPin",
      label: "Position moyenne",
      color: colors.averagePosition,
      tooltipText: METRIC_TOOLTIPS.AVERAGE_POSITION,
      getValue: (currentReport) =>
        currentReport.averagePosition != null
          ? currentReport.averagePosition.toFixed(1)
          : "--",
    },
    {
      key: "positionedDomains",
      icon: "Network",
      label: "Domaines positionnés",
      color: colors.positionedDomains,
      tooltipText: METRIC_TOOLTIPS.POSITIONED_DOMAINS,
      getValue: (currentReport) => formatNumber(currentReport.positionedDomainCount),
    },
    {
      key: "totalSearchVolume",
      icon: "Search",
      label: "Volume de recherche",
      color: colors.totalSearchVolume,
      tooltipText: METRIC_TOOLTIPS.TOTAL_SEARCH_VOLUME,
      getValue: (currentReport) => formatNumber(currentReport.totalSearchVolume),
    },
  ], [colors]);

  return (
    <div className="kpi-grid">
      {cards.map((card) => {
        const value = report ? card.getValue(report) : "--";
        const iconColor = report ? card.color : undefined;

        return (
          <KPICard
            key={card.key}
            icon={card.icon}
            label={card.label}
            value={value}
            iconColor={iconColor}
            tooltipText={card.tooltipText}
          />
        );
      })}
    </div>
  );
};

export default KPIGrid;
